import { Helmet } from "react-helmet-async";
import linkPreviewAsset from "@/assets/link-preview.jpg.asset.json";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  path?: string;
}

const SITE_URL = "https://inparadisebeauty.com";
const DEFAULT_TITLE = "In Paradise Beauty";
const DEFAULT_DESC = "Luxury nails, lashes, pedicures & skincare. Explore Services & Experiences and book your appointment.";
const DEFAULT_IMAGE = `${SITE_URL}${linkPreviewAsset.url}`;

const SEO = ({ title, description, image, path }: SEOProps) => {
  const fullTitle = title ?? DEFAULT_TITLE;
  const desc = description ?? DEFAULT_DESC;
  const img = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : DEFAULT_IMAGE;
  const url = path ? `${SITE_URL}${path}` : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="In Paradise Beauty" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {img && <meta property="og:image" content={img} />}
      {img && <meta property="og:image:width" content="1200" />}
      {img && <meta property="og:image:height" content="630" />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
};

export default SEO;
